import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton
} from '@material-ui/core';


interface IDesignedConfirmDialog {
  title?: string,
  children: React.ReactNode,
  open: boolean,
  // eslint-disable-next-line no-unused-vars
  setOpen: (arg: boolean) => void,
  onConfirm: () => void
}

const DesignedConfirmDialog = (
  { title, children, open, setOpen, onConfirm }: IDesignedConfirmDialog
) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog"
      PaperProps={{
        className: 'border-radius-6'
      }}
      fullWidth
      maxWidth={'sm'}
    >
      <DialogTitle id="confirm-dialog" className="flex-column w-full p-3">
        <div className="flex justify-end">
          <IconButton
            size="small"
            onClick={() => setOpen(false)}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
        <div className="px-10 text-center text-18 font-bold">{title}</div>
      </DialogTitle>
      <DialogContent className="text-center px-8 pb-5">{children}</DialogContent>
      <DialogActions className="flex items-center justify-center px-8 pb-8">
        <Button
          variant="contained"
          onClick={() => {
            setOpen(false);
            onConfirm();
          }}
          color="primary"
          size="small"
          className="uppercase"
        >
          Yes
        </Button>
        <Button
          variant="contained"
          onClick={() => setOpen(false)}
          size="small"
          className="uppercase ml-5"
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DesignedConfirmDialog;
